import DarkModeOutlined from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlined from "@mui/icons-material/LightModeOutlined";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import { HamburgerMenu, RefineThemedLayoutV2HeaderProps } from "@refinedev/mui";

import React, { useContext } from "react";
import { ColorModeContext } from "../../providers/colorProvider";
import { UserMenu } from "./UserMenu";
import { LanguageSelect } from "./LanguageSelect";

type HeaderProps = RefineThemedLayoutV2HeaderProps;

export const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { sticky = false } = props;
  const { mode, toggleMode } = useContext(ColorModeContext);

  return (
    <AppBar position={sticky ? "sticky" : "relative"}>
      <Toolbar>
        <HamburgerMenu />
        <Stack
          direction="row"
          width="100%"
          justifyContent="flex-end"
          alignItems="center"
        >
          <IconButton
            sx={{ marginX: "16px" }}
            color="inherit"
            onClick={toggleMode}
          >
            {mode === "dark" ? <LightModeOutlined /> : <DarkModeOutlined />}
          </IconButton>
          <LanguageSelect />
          <UserMenu />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
